/* eslint-disable react/jsx-no-target-blank */
import {SidebarMenuTabsItem} from '../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuTabsItem'
import {SidebarMenuItemWithSub} from '../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItemWithSub'
import {useCentral} from '../../../../hooks/useCentral'
import {TabCentralModel} from '../../../../models'

const SidebarMenuCentral = () => {
  const {addTab, changeTab, menu, tabs} = useCentral()

  const addTabToContainer = (tab: TabCentralModel) => {
    // Verificar si ya existe una pestaña con el mismo submenu
    const existingTabIndex = tabs.findIndex(
      (existingTab) => existingTab.submenu === tab.submenu && existingTab.vista === tab.vista
    )
    
    if (existingTabIndex !== -1) {
      // Si ya existe, simplemente activarla
      changeTab(existingTabIndex)
    } else {
      // Si no existe, agregar una nueva pestaña
      changeTab(addTab(tab))
    }
  }

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>CENTRAL</span>
        </div>
      </div>
      {menu &&
        menu.length > 0 &&
        menu.map((item) => {
          // const existOption = item.opciones ? true : false
          // const canList =
          //   existOption && item?.opciones.some((item: any) => item.opcion === 'ACCESO')
          // const isShow = canList
          // if (!isShow) return <></>
          return (
            <SidebarMenuItemWithSub
              key={item.id}
              to='/crafted/accounts'
              title={item.name}
              icon='/media/icons/duotune/communication/com006.svg'
              fontIcon='bi-person'
            >
              {item.arraySubItem.map((subItem: any) => {
                const existOption = subItem.opciones ? true : false
                const canList =
                  existOption && subItem?.opciones.some((item: any) => item.opcion === 'ACCESO')
                const isShow = canList
                if (!isShow) return <></>
                return (
                  <SidebarMenuTabsItem
                    key={subItem.id}
                    to='/central/clientes'
                    title={subItem.title}
                    hasBullet={true}
                    onClickHandler={() => addTabToContainer(subItem)}
                  />
                )
              })}
            </SidebarMenuItemWithSub>
          )
        })}
    </>
  )
}

export {SidebarMenuCentral}
